import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateExemption } from '../types';

const onCreateExemption: IThunkCreateExemption = thunk(async (_, { exemption, ...client }) => {
  await api.communityEngagement.createExemption(client, exemption);
});

export default onCreateExemption;
